import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// ── CSS de terceros ───────────────────────────────────────────────────────────
// CoreUI 5 ya incluye Bootstrap 5 — no importar bootstrap por separado
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const container = document.getElementById('root');
const root      = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
